<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="How To Care For Your French Oven">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e303" xmlns:saxon="http://icl.com/saxon">How To
              Care For Your French Oven </a></h1><a id="d0e303" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e303" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e303" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e303" xmlns:saxon="http://icl.com/saxon">
<p>When you take your new French oven out of the box, remove all labels and stickers from it
        before using. Wash it, rinse, and dry. Normally, French ovens are easy to clean and require
        only a sponge and hot soapy water. </p>
<p>French ovens should be gently brought up to temperature and used on medium- to medium-high
        heat, rather than at a high stovetop heat that can cause food scorching. They are the ideal
        vessel for slow cooking at low to medium temperatures. If you are searing or browning, you
        can do it on medium to medium-high heat. Only use French ovens on high stovetop temperatures
        to boil water or to reduce sauces. Instead, for high temperature cooking, use sturdy
        skillets. </p>
<p>On induction stovetops, take care to lift the French oven on and off it rather than sliding
        it, so as not to scratch the surface. Increase the heat gently on an induction stovetop, for
        about 4 minutes, until turning up to desired heat, and do not cook on the maximum setting or
        use the booster option. Remember, Mauviel’s copper French ovens are not recommended to be
        used on induction stovetops. </p>
<p>For all French ovens, use wooden or heat-resistant utensils. </p>
<p>After cooking, let your French oven cool for 15 minutes before using soapy water and a soft
        sponge or plastic scouring pad to clean it. </p>
<p>Use nonabrasive products to clean the ovens and do not use steel wool, abrasive pads, or
        abrasive cleaning agents as they may dull the interior. If food has become burnt on, try
        simmering some water and a little white vinegar and baking soda for a while in the French
        oven and try to move the food off the bottom with a wooden spoon then let it soak in this
        mixture overnight. If that does not work, try again by adding 1/2 inch (1.25 cm) hydrogen
        peroxide and 2 teaspoons baking soda to your French oven, bring to a simmer, and cook for 8
        to 10 minutes then scrub with a brush. Make sure you have your vent turned on as it will
        smell as you do this. You should be able to clean the French oven this way and not scratch
        or damage the interior. </p>
<p>For Staub French ovens that have black interiors, use a little vinegar and gentle detergent
        with hot water to clean. If it develops a white film from cooking, add a little baking soda
        to hot water and clean with a sponge. </p>
<div class="mediaobject" title="Photo of advertisment.">
<img alt="Photo of advertisment." src="images/IMG_0458.jpg"/>
</div>
</a></div><a id="d0e303" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch04.vue?26d3ca00